export class DayJsConfig {
  // Thresholds are base on the default value in dayjs/plugin/relativeTime
  static relativeTimeConfig = {
    thresholds: [
      { l: 's', r: 44, d: 'second' },
      { l: 'm', r: 89 },
      { l: 'mm', r: 44, d: 'minute' },
      { l: 'h', r: 89 },
      { l: 'hh', r: 23, d: 'hour' }, // Customize base on our requirement
      { l: 'd', r: 35 },
      { l: 'dd', r: 25, d: 'day' },
      { l: 'M', r: 45 },
      { l: 'MM', r: 10, d: 'month' },
      { l: 'y', r: 17 },
      { l: 'yy', d: 'year' },
    ],
  };

  // This is to map locale of dayjs incase our locale have discrepancy in it.
  // Check dayjs locale list here https://github.com/iamkun/dayjs/tree/dev/src/locale
  static localeCodeMapper(localeCode: string): string {
    const code = localeCode.toLowerCase();
    switch (code) {
      case 'en-us':
        return 'en';
      case 'fr-fr':
        return 'fr';
      case 'ar-ae':
        return 'ar';
      case 'ko-kr':
        return 'ko';
      default:
        return code;
    }
  }
}
